import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  BuildingEquipmentQrCodeService,
  QrCodeService,
  TenantFilterDto,
} from '@artemis-software/wr-api';
import { asyncComputed } from '@/utils/signals/asyncComputed';
import { firstValueFrom } from 'rxjs';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';
import { qrBuildingContext } from '@services/qr-building-context.service';

@Component({
  standalone: false,
  selector: 'wr-qr-code-tga-overview-page',
  templateUrl: './qr-code-tga-overview-page.component.html',
  styleUrls: ['./qr-code-tga-overview-page.component.scss'],
})
export class QrCodeTgaOverviewPageComponent extends AbstractFormControl<TenantFilterDto.FacilityElementEnum> {

  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly qrCodeService = inject(QrCodeService);
  private readonly buildingEquipmentQrCodeService = inject(BuildingEquipmentQrCodeService);

  readonly context = qrBuildingContext();
  readonly loading = signal(false);

  readonly facilityElements =
    asyncComputed<TenantFilterDto.FacilityElementEnum[]>(async () => {
      const buildingSectionId = this.context.sectionId();
      const session = this.context.session();
      if (!buildingSectionId || !session || this.context.isExternal()) {
        return [] as TenantFilterDto.FacilityElementEnum[];
      }
      return await firstValueFrom(
        this.qrCodeService.getAllFacilityElementsForContractorByBuildingSectionId(buildingSectionId),
      ) as TenantFilterDto.FacilityElementEnum[];
    }, []);

  readonly tgaList = asyncComputed(() => {
    const buildingSectionId = this.context.sectionId();
    const allowedFacilityElements = this.facilityElements();
    const selectedFacilityElement = this.valueSignal();

    if (!buildingSectionId) return [];

    const facilityElementsToFilter = selectedFacilityElement ? [selectedFacilityElement] : allowedFacilityElements;

    return this.buildingEquipmentQrCodeService.findAll({
      buildingSectionId,
      facilityElements: facilityElementsToFilter,
    });
  }, undefined, this.loading);

  goToDetail(buildingEquipmentId: string): void {
    this.router.navigate([buildingEquipmentId], { relativeTo: this.route });
  }

}
